import React, { useRef, useState, useEffect } from "react";
import ContentEditable from "react-contenteditable";
import { Input, LooksOne, Done, DoneAll } from "@material-ui/icons";
import { ClipLoader } from "react-spinners";
import { acceptTranslatedSegment, injectTagAction, generateSegmentIsOpenAction } from "../reducers/segmentsReducer";
import { connect } from "react-redux";
import { validationLoading } from "../reducers/validationReducer";
import SegmentValidationPresenter from "./SegmentValidationPresenter";
import { svrSelector, generateSegmentValidationAction } from "../reducers/validationReducer";
import { validationSegment } from "../services/Connector";
import { languageSelectors } from "../reducers/laguagesReducer";
import { selectTranslationModel } from "../reducers/translationReducer";
import { segmentsSelectors, segmentStateSelector } from "../reducers/segmentsReducer";
import Enumerable from "linq";

const Target = (props) => {
  const text = useRef("");
  const div = React.createRef();

  //STATE
  const [showToolBar, setToolBar] = useState(false);

  const segmentFocus = () => {
    const nestField = document.getElementById(`target${1}`);
    nestField.focus();
  };
  useEffect(() => {
    segmentFocus();
  }, []);

  const onOpenSegmentFocus = (id) => {
    props.onOpen(id);
    const finded = props.segments.find((x) => x.TargetId === id);
    if (finded !== undefined) {
      setToolBar(true);
    } else {
      setToolBar(false);
    }
  };
  const onTextChange = (e) => {
    //text.current = e.target.value;
  };

  const onKeyDown = (e, id, div) => {
    //On press Enter
    if (e.keyCode === 13 && !e.ctrlKey && !e.altKey) {
      e.preventDefault();
      //let text = targetText === "undefined" || targetText === "" ? props.segment.TargetTextHtml : targetText;

      props.onValidation({ id: id, text: div.innerHTML });

      //props.OnAcceptSegment({ id, text: div.innerHTML });
      const nestField = document.getElementById(`target${id + 1}`);
      nestField.focus();
      //setToolBar(false);

      // dispatch(acceptSegmentTranslation(id, text));
    }
    //On press Ctrl+sapce
    if (e.ctrlKey && e.key === " ") {
      props.OnInjectTag(props.segment.SourceId);
    }
  };

  let className = "target-wraper card mx-0 my-0";
  if (props.segment.isOpened) {
    className += " target-opened";
  }

  const onClickInsertTagBtn = () => {
    props.OnInjectTag(props.segment.SourceId);
    setToolBar(true);
  };

  let showValidation = false;
  if (props.svrIds.length > 0 && props.svrIds.includes(props.segment.TargetId)) {
    //Use linq to find segments with warnings or errors
    let is_warning = Enumerable.from(Object.values(props.segmentValidation)).any((x) => x.state === 2);
    let is_error = Enumerable.from(Object.values(props.segmentValidation)).any((x) => x.state === 3);
    showValidation = is_error || is_warning;
  }

  const onClickAcceprSegmentClick = (id, targetText, div) => {
    //   props.onValidation({ id: id, text: div.current.innerHTML });
    props.OnAcceptSegment({ id: id, text: div.current.innerHTML });
    const nestField = document.getElementById(`target${id + 1}`);
    nestField.focus();
  };

  const onSegmentBlur = (e, id, targetText) => {
    let text = targetText === "undefined" || targetText === "" ? props.segment.TargetTextHtml : targetText;
  };
  //let html = ConvertTagsToHtml(segment.targetText);

  return (
    <div className="target-control">
      <div className={className}>
        <ContentEditable
          id={"target" + props.segment.SourceId}
          // html={html.ResultHTML}
          html={props.segment.TargetTextHtml}
          className="target"
          onChange={onTextChange}
          onKeyDown={(e) => onKeyDown(e, props.segment.SourceId, div.current, props.segment.TargetId)}
          // onFocusCapture={() => onOpenSegmentFocus(props.segment.TargetId)}
          onFocus={() => onOpenSegmentFocus(props.segment.TargetId)}
          onBlur={(e) => onSegmentBlur(e, props.segment.TargetId, text.current)}
          innerRef={div}
        />

        {props.segment.isAccepted ? (
          <div className="segment-accepted">
            <Done color="success" titleAccess="Human Proofread"></Done>
          </div>
        ) : (
          <div></div>
        )}
      </div>
      <div className="target-validation-presentation">
        {showValidation ? (
          <div>
            <SegmentValidationPresenter SegmentValidationResult={props.segmentValidation} segment={props.segment} />
          </div>
        ) : (
          <div></div>
        )}
      </div>
      {props.segment.isOpened && props.segment.SourceTags.length > 1 ? (
        <div className="target-toolbar">
          {/* <Input titleAccess="Copy source to target (Alt + Ins)" onClick={() => props.onCopySource(props.segment.TargetId)}></Input> */}
          <div className="right">
            {props.segmentValidation.loading === true ? (
              <ClipLoader size={16} sizeUnit={"px"} color={"#20AE9B"}></ClipLoader>
            ) : (
              <span>
                {/* {" "}
                <Done titleAccess="Save this segment and open next (Enter)" onClick={(e) => onClickAcceprSegmentClick(props.segment.TargetId, text.current, div)}></Done> */}
              </span>
            )}
          </div>

          {props.segment.SourceTags.length > 1 && (
            <div className="left">
              <LooksOne htmlColor="red" titleAccess="Insert tag (Ctrl + Space)" onClick={() => onClickInsertTagBtn()}></LooksOne>
            </div>
          )}
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    segments: segmentsSelectors.selectAll(state),
    segmentsState: segmentStateSelector(state),
    segmentValidation: svrSelector.selectAll(state),
    svrIds: svrSelector.selectIds(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    OnAcceptSegment: (id, text) => dispatch(acceptTranslatedSegment(id, text)),
    OnInjectTag: (TargetId) => dispatch(injectTagAction(TargetId)),
    onOpen: (TargetId) => dispatch(generateSegmentIsOpenAction(TargetId)),
    //onCopySource: (TargetId) => dispatch(generateCopySourceAction(TargetId)),
    //onValidation: (sourceId, targetId) => dispatch(genarateSegmentValidationAction(sourceId, targetId)),
    //onSegmentOpen: (TargetId) => dispatch(updateOpenEditorTargetId(TargetId)),
    //onValidation: (sourceId, targetId) => dispatch(generateAcceptSegmentAction(sourceId, targetId)),
    onValidation: (sourceId, targetId) => dispatch(generateSegmentValidationAction(sourceId, targetId)),
    validationLoading: () => dispatch(validationLoading()),

    //segments: (data) => dispatch(reduceDiplayedSegments(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Target);
